"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
require("./areasOfExpertise.scss");
const AreasOfExpertise = (props) => {
    return (react_1.default.createElement(core_1.Box, { id: 'areas-of-expertise', className: `v2-container-background ${props.className}` },
        react_1.default.createElement("h4", { className: 'v2-profile-block-heading' }, props.heading),
        react_1.default.createElement("div", { className: 'areas' }, props.areas.map((el, i) => {
            return react_1.default.createElement("a", { href: `#/directory/${props.link}?id=${el.id}&name=${el.name}&parent_id=${el.parent_id || el.service_id}`, key: i, className: "area" }, el.name);
        }))));
};
exports.default = AreasOfExpertise;
